import { aciCheckSimple, aciCloseAlt, aciMagic } from '@am/common-svg-icons';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DisneyNameMealPLan } from '@core/models/MealPlan/DisneyNameMealPlan.enum';
import { ISupplement } from '@core/models/Supplement/Supplement.iterface';
import { MbExpandablePanel, MbIcon, MbButton } from '@am/moebius';
import { Rate } from '@core/models/Rate/Rate.model';
import { AmExpandableGroupComponent } from '@commons/am-expandable-group/am-expandable-group.component';

@Component({
    selector: 'meal-plan-disney',
    templateUrl: './meal-plan.component.html',
    styleUrls: ['./meal-plan.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        AmExpandableGroupComponent,
        MbIcon,
        MbButton,
    ],
})
export class MealPlanDisneyComponent implements OnInit, AfterViewInit {
  @ViewChild('mealPlanExpandable')
  mealPlanExpandablePanel: MbExpandablePanel;

  @Input()
  public selected: boolean;

  @Input()
  public included = false;

  @Input()
  public disabled = false;

  @Input()
  public rate: Rate;

  @Input() set ticketSelected(ticketSelected: ISupplement) {
    this.ticket = ticketSelected;
  }

  @Input()
  public isExperts = false;

  @Output()
  public selectedMealPlan: EventEmitter<boolean> = new EventEmitter<boolean>();

  ticket: ISupplement = null;
  check = aciCheckSimple;
  close = aciCloseAlt;
  magic = aciMagic;
  open = false;
  public enumDisneyMealPlan = DisneyNameMealPLan;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  public ngAfterViewInit(): void {
    if (this.mealPlanExpandablePanel !== undefined) {
      if (this.isExperts) {
        if (this.open) {
          this.mealPlanExpandablePanel.open();
        } else {
          this.mealPlanExpandablePanel.close();
        }
      }
    }
    this.cdr.detectChanges();
  }

  selectMealPlan() {
    this.selectedMealPlan.emit(true);
  }

  deleteMealPlan() {
    this.selectedMealPlan.emit(false);
  }

  get mealPlanName() {
    return this.rate.meal_plan.description;
  }
}
